var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Administración de Menus","active":""}},[_c('app-permission-manager-page')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Permisos"}},[_c('app-capabilities-manager-page')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }